import React, { useState } from "react";
import { sendChat } from "../api";
import "./ChatBot.css";

function ChatBot({ onMealAdded }) {
    const [chatInput, setChatInput] = useState("");
    const [chatLog, setChatLog] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleChatSubmit = async (e) => {
        e.preventDefault();
        if (!chatInput.trim()) return;

        const userMsg = { role: "user", content: chatInput };
        const updatedLog = [...chatLog, userMsg];
        setChatLog((prev) => [...prev, userMsg]);
        setChatInput("");
        setIsLoading(true);

        try {
            const data = await sendChat(userMsg.content);
            const aiMsg = { role: "ai", content: data.reply };
            setChatLog([...updatedLog, aiMsg]);
            if (onMealAdded) onMealAdded();
        } catch (error) {
            setChatLog((prev) => [...prev, { role: "ai", content: error.response?.status === 429
                ? "The demo's AI limit has been reached for now, please try again later."
                : "Chat is unavailable right now, try again" }]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="chat-container">
            <h3>AI Nutritionist</h3>
            <div className="chat-log">
                {chatLog.map((msg, i) => (
                    <div key={i} className={`chat-message ${msg.role}`}>
                        <b>{msg.role.toUpperCase()}:</b>
                        <p>{msg.content}</p>
                    </div>
                ))}
                {isLoading && <p className="loading-text"><i>Chef is thinking...</i></p>}
            </div>
            <form className="chat-form" onSubmit={handleChatSubmit}>
                <input
                    type="text"
                    value={chatInput}
                    onChange={(e) => setChatInput(e.target.value)}
                    placeholder="I ate a banana..."
                    className="chat-input"
                    disabled={isLoading}
                />
                <button type="submit" className="chat-submit" disabled={isLoading}>
                    Send
                </button>
            </form>
        </div>
    );
}

export default ChatBot;
